import {default as axios, AxiosStatic, AxiosInstance} from 'axios';
import {AxiosAuthHttp, IAxiosOptions} from './axiosAuthHttp';


export default class Api {
    private static apiInstance: AxiosInstance;

    private constructor() { }

    public static get Instance() {
        if (this.apiInstance === null || this.apiInstance === undefined) {

            const options: IAxiosOptions = {
                baseUrl: String(process.env.VUE_APP_API_ENDPOINT),
                resourceId: String(process.env.VUE_APP_API_ID),
                };

            this.apiInstance = AxiosAuthHttp.CreateClient(options);
        }
        return this.apiInstance;
    }
}
